import { TreeNode } from "@/types/tree";
import {
  isColumnsElement,
  getColumnsElement,
  getColumnWidth
} from "@/lib/columns/helpers";
import { changeColumnWidthAndCommitToStore } from "./store";
import { parseFloatAndFixTo2Digits } from "@/util/math";

export function rewidthColumnsAndCommitToStore(
  columnOrColumnsElementOrId: TreeNode | TreeNode["id"],
  indexToIgnore?: number,
  noRecurse?: boolean
) {
  const columnsElement = getColumnsElement(columnOrColumnsElementOrId);

  if (
    !columnsElement ||
    !isColumnsElement(columnsElement) ||
    columnsElement.children.length === 0
  )
    return;

  let columnWidth: number;
  let totalWidth: number;

  if (indexToIgnore === undefined) {
    columnWidth = parseFloatAndFixTo2Digits(
      100 / columnsElement.children.length
    );
    totalWidth = columnWidth * columnsElement.children.length;
  } else {
    const columnToIgnore = columnsElement.children[indexToIgnore];

    if (!columnToIgnore) return;

    const columnToIgnoreWidth = getColumnWidth(columnToIgnore);

    columnWidth = parseFloatAndFixTo2Digits(
      (100 - columnToIgnoreWidth) / (columnsElement.children.length - 1)
    );

    totalWidth =
      columnWidth * (columnsElement.children.length - 1) + columnToIgnoreWidth;
  }

  /* 
    im trying to force the widths to 100%, not 99.99%,
    i.e. if we get 33.33 33.33 33.33 from the above code 
    but javascript is being a little bitch, because according 
    to google chrome's console, 16.67 * 6 = 100.02000000000001... 
    what the fuck. so that's why I'm doing the rounding and shit.
    hopefully it works. 
  */

  const lastColumnWidth =
    totalWidth === 100
      ? columnWidth
      : parseFloatAndFixTo2Digits(100 - totalWidth + columnWidth);

  if (columnWidth < 0 || lastColumnWidth < 0) {
    if (noRecurse !== true) {
      /* if this shit be negative, something would be fucked up, 
      so i'd say we should rewidth everything evenly as a 'reset', 
      but that means calling rewidthColumnsAndCommitToStore(columnsElement);
      again,  which is dangerous because maybe we'll end up in a recursive 
      loop, hence the noRecurse flag */
      rewidthColumnsAndCommitToStore(columnsElement, undefined, true);
    }
  } else {
    /* the happy path */
    columnsElement.children.forEach((column, index, columnsArray) => {
      if (index === indexToIgnore) return;

      const newWidth =
        index === columnsArray.length - 1 ? lastColumnWidth : columnWidth;

      changeColumnWidthAndCommitToStore(column.id, newWidth);
    });
  }
}
